<div class="sml-control-group tw-relative">
  <input 
    type="text" 
    #googleAutocompletPlaceSearch 
    id="googleAutocompletPlaceSearch" 
    placeholder="Start typing Address" 
    class="sml-control" 
    [formControl]="addressControl"
    [(ngModel)]="address" 
    [ngClass]="{'sml-control-error': isInvalid}"
    />
    @if(showLocationIcon){
      <i-icon 
      [name]="'location-blue'" 
      class="tw-absolute tw-text-[#106B8E] tw-right-3 tw-top-1/2 tw-transform -tw-translate-y-1/2 tw-pointer-events-none">
    </i-icon>
  }
</div>
